import React, { useEffect } from "react";
import { Form, Input, Button, Upload, message, Spin } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getAmenityById, updateAmenity } from "../../features/amenitySlice";
import App from "../../Utils/LayoutMobile";
import { useNavigate, useParams } from "react-router-dom";

const UpdateAmenity = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { loading, selectedAmenity } = useSelector((state) => state.amenities);

  useEffect(() => {
    if (id) {
      dispatch(getAmenityById(id))
        .unwrap()
        .then((data) => {
          form.setFieldsValue({
            name: data.name,
            description: data.description,
            icon: data.icon
              ? [
                  {
                    uid: "-1",
                    name: "existing-icon",
                    status: "done",
                    url: data.icon,
                  },
                ]
              : [],
          });
        })
        .catch(() => message.error("Failed to fetch amenity"));
    }
  }, [id, dispatch, form]);

  const handleSubmit = (values) => {
    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("description", values.description || "");

    const file = values.icon?.[0];
    if (file) {
      if (file.originFileObj) {
        formData.append("icon", file.originFileObj); // New upload
      }
      // else keep existing image (no need to add anything to FormData)
    }

    dispatch(updateAmenity({ id, formData }))
      .unwrap()
      .then(() => {
        message.success("Amenity updated successfully");
        navigate("/Amenity");
      })
      .catch((error) => {
        message.error(error || "Failed to update amenity");
      });
  };

  return (
    <App>
      <Spin spinning={loading}>
        <h2 style={{ marginBottom: 24 }}>Update Amenity</h2>
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
          style={{ maxWidth: 500 }}
        >
          <Form.Item
            name="name"
            label="Amenity Name"
            rules={[{ required: true, message: "Please enter amenity name" }]}
          >
            <Input placeholder="Enter amenity name" />
          </Form.Item>

          <Form.Item name="description" label="Description">
            <Input.TextArea rows={3} placeholder="Enter description (optional)" />
          </Form.Item>

          <Form.Item
            name="icon"
            label="Icon Image"
            valuePropName="fileList"
            getValueFromEvent={(e) => e?.fileList}
          >
            <Upload
              beforeUpload={() => false}
              maxCount={1}
              listType="picture"
              defaultFileList={form.getFieldValue("icon")}
            >
              <Button icon={<UploadOutlined />}>Upload Icon</Button>
            </Upload>
          </Form.Item>

          <Form.Item style={{ textAlign: "right" }}>
            <Button style={{ marginRight: 8 }} onClick={() => navigate("/Amenity")}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Update Amenity
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </App>
  );
};

export default UpdateAmenity;
